import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const BookedDateField = ({ job, canEdit, onSaved }) => {
  const [d, setD] = useState((job.booked_date || "").slice(0, 10));
  const [busy, setBusy] = useState(false);
  useEffect(() => setD((job.booked_date || "").slice(0, 10)), [job.booked_date]);
  const changed = d && d !== (job.booked_date || "").slice(0, 10);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/jobs/${job.id}`, { booked_date: d });
      onSaved(data);
      toast.success("Booking date updated on the Slot Chart");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
      setD((job.booked_date || "").slice(0, 10));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="job-booked-date-block">
      <Label>Booked for</Label>
      {canEdit ? (
        <div className="mt-1.5 flex gap-2">
          <Input type="date" value={d} onChange={(e) => setD(e.target.value)} data-testid="job-booked-date-input" />
          {changed && (
            <Button onClick={save} disabled={busy} data-testid="job-booked-date-save">{busy ? "Saving…" : "Save"}</Button>
          )}
        </div>
      ) : (
        <p className="mt-1.5" data-testid="job-booked-date-text">{job.booked_date ? job.booked_date.slice(0, 10) : "—"}</p>
      )}
    </div>
  );
};
